import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'ng-select';
import { BsDatepickerModule, ModalModule, TooltipModule } from 'ngx-bootstrap';
import { BoxRetalStampsModule } from '../share/boxRetalStamps/boxRetalStamps.module';
import { HistoryBoxModule } from '../history-box/history-box.module';
import { Select2ApiModule } from '../share/select2Api/select2Api.module';
import { BoxRetalStampsTHModule } from '../share/boxRetalStampsTH/boxRetalStampsTH.module';
import { IntegrateLoyaltyComponentV2 } from './integrate-loyalty-v2.component';
import { IntegrateLoyaltyViewProductComponent } from './integrate-loyalty-view-product/integrate-loyalty-view-product.component';
import { IntegrateLoyaltyViewAgencyComponent } from './integrate-loyalty-view-agency/integrate-loyalty-view-agency.component';
import { IntegrateLoyaltyViewStampComponent } from './integrate-loyalty-view-stamp/integrate-loyalty-view-stamp.component';
import { ConfigLoyaltyProductComponent } from './config-loyalty-product/config-loyalty-product.component';
import { ConfigLoyaltyStampComponent } from './config-loyalty-stamp/config-loyalty-stamp.component';
import { ConfigLoyaltyAgencyComponent } from './config-loyalty-agency/config-loyalty-agency.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
    BoxRetalStampsModule,
    HistoryBoxModule,
    Select2ApiModule,
    ModalModule,
    BoxRetalStampsTHModule,
    TranslateModule.forChild(),
  ],
  exports: [
    ConfigLoyaltyProductComponent
  ],
  declarations: [
    IntegrateLoyaltyComponentV2,
    IntegrateLoyaltyViewProductComponent,
    IntegrateLoyaltyViewAgencyComponent,
    IntegrateLoyaltyViewStampComponent,
    ConfigLoyaltyProductComponent,
    ConfigLoyaltyStampComponent,
    ConfigLoyaltyAgencyComponent,
  ]
})
export class IntegrateLoyaltyV2Module {
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/integrate-loyalty-v2/integrate-loyalty-v2.module.ts